import React, { createContext, useContext, useReducer, useCallback } from 'react';

const SessionContext = createContext(null);

const MAX_SESIONES = 8;

const initialState = { sesiones: [], sesionActiva: null };

function reducer(state, action) {
  switch (action.type) {
    case 'ABRIR': {
      const id = `${action.tipo}_${action.entityId}`;
      const existe = state.sesiones.find(s => s.id === id);
      if (existe) return { ...state, sesionActiva: id };
      if (state.sesiones.length >= MAX_SESIONES) return state;
      return {
        sesiones: [...state.sesiones, { id, tipo: action.tipo, entityId: action.entityId, titulo: action.titulo, subTab: 'resumen', itemTabs: [] }],
        sesionActiva: id,
      };
    }
    case 'CERRAR':
      return {
        sesiones: state.sesiones.filter(s => s.id !== action.id),
        sesionActiva: state.sesionActiva === action.id ? null : state.sesionActiva,
      };
    case 'ACTIVAR':
      return { ...state, sesionActiva: action.id };
    case 'IR_INICIO':
      return { ...state, sesionActiva: null };
    case 'CAMBIAR_SUBTAB':
      return {
        ...state,
        sesiones: state.sesiones.map(s => s.id === action.sesionId ? { ...s, subTab: action.subTab } : s),
      };
    case 'ABRIR_ITEM_TAB': {
      const tabId = `${action.tipo}_${action.entityId}`;
      return {
        ...state,
        sesiones: state.sesiones.map(s => {
          if (s.id !== action.sesionId) return s;
          const yaExiste = (s.itemTabs || []).find(t => t.id === tabId);
          const itemTabs = yaExiste ? s.itemTabs : [...(s.itemTabs || []), { id: tabId, tipo: action.tipo, entityId: action.entityId, titulo: action.titulo, ...action.datos }];
          return { ...s, itemTabs, subTab: tabId };
        }),
      };
    }
    case 'CERRAR_ITEM_TAB': {
      return {
        ...state,
        sesiones: state.sesiones.map(s => {
          if (s.id !== action.sesionId) return s;
          const itemTabs = (s.itemTabs || []).filter(t => t.id !== action.tabId);
          const subTab = s.subTab === action.tabId ? 'resumen' : s.subTab;
          return { ...s, itemTabs, subTab };
        }),
      };
    }
    default:
      return state;
  }
}

export function SessionProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const abrirSesion    = useCallback((tipo, entityId, titulo) => dispatch({ type: 'ABRIR', tipo, entityId, titulo }), []);
  const cerrarSesion   = useCallback((id) => dispatch({ type: 'CERRAR', id }), []);
  const activarSesion  = useCallback((id) => dispatch({ type: 'ACTIVAR', id }), []);
  const irInicio       = useCallback(() => dispatch({ type: 'IR_INICIO' }), []);
  const cambiarSubTab  = useCallback((sesionId, subTab) => dispatch({ type: 'CAMBIAR_SUBTAB', sesionId, subTab }), []);
  const abrirItemTab   = useCallback((sesionId, tipo, entityId, titulo, datos = {}) => dispatch({ type: 'ABRIR_ITEM_TAB', sesionId, tipo, entityId, titulo, datos }), []);
  const cerrarItemTab  = useCallback((sesionId, tabId) => dispatch({ type: 'CERRAR_ITEM_TAB', sesionId, tabId }), []);

  const value = {
    sesiones: state.sesiones,
    sesionActiva: state.sesionActiva,
    abrirSesion, cerrarSesion, activarSesion, cambiarSubTab, irInicio, abrirItemTab, cerrarItemTab,
  };

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession() {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession debe usarse dentro de SessionProvider');
  return ctx;
}

